import { render, staticRenderFns } from "./goods-of-integral.vue?vue&type=template&id=07b89f64&"
import script from "./goods-of-integral.vue?vue&type=script&lang=js&"
export * from "./goods-of-integral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports